



















import { Component, Prop, Vue , Watch } from "vue-property-decorator";

@Component({
  components: {
  },
})
export default class Down extends Vue {
    @Prop() private userConfigColor! : string;
}
